import PlayerResult from './player-result';

export default PlayerResult;
